export default __webpack_public_path__ + "static/media/ekLogo.7986425a.png";